module.exports = __webpack_public_path__ + "static/media/twilight-desktop.4b2b025b.jpg";